import { render } from "./TicketTemplateGroupDialog.vue?vue&type=template&id=507bed18"
import script from "./js/ticketTemplateGroupDialog.js?vue&type=script&lang=js&external"
export * from "./js/ticketTemplateGroupDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__